import * as React from 'react';

import { Seat, SeatZone } from '../../classes/seat';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';

interface IConfirmPromptProps {
    appSettingsModel: IAppSettingsModel;
    onConfirmSeatClick: () => any;
    onCancelSeatClick: () => any;
    confirmPromptText: string;
}

class ConfirmPrompt extends React.Component<IConfirmPromptProps, { confirmed: boolean, needToConfirmError: boolean }>{
    constructor(props) {
        super(props);
        this.state = { confirmed: false, needToConfirmError: false };
    }
    render() {
        return (
            <div className="seat-info-dialog">
                { this.isHtmlPrompt() ?
                    <div className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.confirmPromptText }}></div>
                    :
                    <div>
                        <input id="dialogCheckbox" type="checkbox" className="checkbox-custom" value={this.state.confirmed.toString()} checked={this.state.confirmed}
                            onChange={this._onConfirmChange.bind(this)} /> <label htmlFor="dialogCheckbox">{this.props.confirmPromptText}</label>

                        {this.state.needToConfirmError ?
                            <div className="dialog-wrapper">
                                <div className="dialog-container">
                                    <div>
                                        <h3 className="heading-general">{this.props.appSettingsModel.missingAttestationErrorMessageHeader}</h3>
                                        <p>
                                            {this.props.appSettingsModel.missingAttestationErrorMessageText}
                                    </p>
                                    </div>
                                    <div className="dialog-cta-container">
                                        <button className="dialog-cta-btn" onClick={() => { this._closeDialog() }}>{this.props.appSettingsModel.missingAttestationErrorMessageButton}</button>
                                    </div>
                                </div>
                            </div>
                            : null}
                    </div>
                }

                <div className="seat-info-dialog-cta">
                    <button className="seat-info-dialog-cta-btn" onClick={this.props.onCancelSeatClick}>{this.props.appSettingsModel.attestationSeatCancelButton}</button>
                    <button className="seat-info-dialog-cta-btn" onClick={this._onSelectSeatClick.bind(this)}>{this.props.appSettingsModel.attestationSeatConfirmationButton}</button>
                </div>
            </div>

        );
    }

    isHtmlPrompt() {
        if (this.props.confirmPromptText === null)
            return false;
        return this.props.confirmPromptText.substr(0, 4) === "<div";
    }

    _closeDialog() {
        const newState = {
            ...this.state,
            needToConfirmError: false
        };
        this.setState(newState as any);
    }

    _onSelectSeatClick() {
        if (this.state.confirmed || this.isHtmlPrompt()) {
            this.props.onConfirmSeatClick();
        } else {
            this.setState({
                confirmed: this.state.confirmed,
                needToConfirmError: true
            });
        }
    }

    _onConfirmChange() {
        this.setState({
            confirmed: !this.state.confirmed,
            needToConfirmError: false
        });
    }

}

export default ConfirmPrompt;